export const BADGE_AWARD = 8;
export const BADGE_DEFINITION = 30009;
export const PROFILE_BADGES = 30008;
export const CONTACT_LIST = 3;
